import update from 'immutability-helper'
import React from 'react'
import { makeStyles, withStyles} from 'external/material'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import AddIcon from '@mui/icons-material/Add'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import InboxIcon from '@mui/icons-material/MoveToInbox'
import DraftsIcon from '@mui/icons-material/Drafts'
import SendIcon from '@mui/icons-material/Send'
import CreateAssessmentForm from './form'
import CreateDirectoryForm from './directory-form'

const AddButton = withStyles({
  root: {
    backgroundColor: '#2ca5ec',
    color: '#fff',
    '& svg': {
      marginTop: -3
    },
    '&:hover': {
      backgroundColor: '#0069d9',
      borderColor: '#0062cc',
      boxShadow: 'none',
    },
  }
})(Button)

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  button: {
    flexGrow: 1
  },
  menu: {
  }
}))


const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

export default function CreateAssessmentMenu ({context, simple}) {

  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = (event) => {
    if (simple) handleOpenDialog('create-assessment')()
    else setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null);
  }

  function handleOpenDialog(name) {
    return e => {
      handleClose()
      const quizDialogs = update(context.quizDialogs, {[name]: {$set: true}})
      context.setState({quizDialogs})
    }
  }


  return (
    <div className={classes.root}>
      <AddButton
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant="contained"
        color="primary"
        onClick={handleClick}
        className={classes.button}
      >
        <AddIcon />{context.translate('create')}
      </AddButton>
      <Menu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleOpenDialog('create-assessment')}>{context.translate('create-assessment')}</MenuItem>
        <MenuItem onClick={handleOpenDialog('create-directory')}>{context.translate('create-directory')}</MenuItem>
      </Menu>
      <CreateAssessmentForm context={context} />
      <CreateDirectoryForm context={context} />
    </div>
  )
}

